var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5,0A71.5,71.5,0,1,0,143,71.5,71.57,71.57,0,0,0,71.5,0Zm0,135A63.5,63.5,0,1,1,135,71.5,63.58,63.58,0,0,1,71.5,135Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.46,
    cy: 49.18,
    r: 7.04,
    transform: "translate(-6.96 12.08) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,63.09H69.09A2.85,2.85,0,0,0,66,66.2v35a2.91,2.91,0,0,0,3.11,3.19h4.74c2,0,3-1.23,3-3.19v-35A2.78,2.78,0,0,0,73.83,63.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.a4de5d3fc1d1dfa7319b5c667de45f71.svg";
export { ForwardRef as ReactComponent };